module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ily4O6/tc-custom/9781426815843.jpg?1705766125411",
      "alt": "This image is the cover for the book Howling in the Darkness, Moriah's Landing"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Howling in the Darkness, Moriah's Landing\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("GUARDIAN OF THE NIGHTDanger! Undercover agent Jonah Ries couldn't explain to the stunning woman who'd mistaken him for herblind date exactly how he knew someone was trying to harm her. Butevil stalked Moriah's Landing, and Katherine Ridgemont was its target.When she learned of Jonah's deep secret, Kat might not give him thetime of day. Only that wouldn't stop Jonah from watching over thevulnerable beauty after dark. As the anniversary of Kat's mother'smysterious death approached, the instinct to protect became a fire inJonah's blood. A fire matched by his determination to save the womanhe loved from the unknown forces that haunted the night….")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      B. J. Daniels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("New York Times and USA Today bestselling author B.J. Daniels lives in Montana with her husband, Parker, and two springer spaniels. When not writing, she quilts, boats and always has a book or two to read. Contact her at "), _c('a', {
    attrs: {
      "href": "http://www.bjdaniels.com/"
    }
  }, [_vm._v("www.bjdaniels.com")]), _vm._v(", on Facebook at B.J. Daniels or through her reader group the B.J. Daniels' Big Sky Darlings, and on twitter at bjdanielsauthor.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0